<ng-container *ngIf="_common.isBrowser">
  <div class="col-lg-6 align-self-center text-center text-lg-start">
    <h5 class="fw-bold page-title mb-3">
      {{ title }}
    </h5>
  </div>
  <owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let item of sports | sort: 'winnings':'desc'">
      <ng-container *ngIf="item.rank || item.rank == 0">
        <ng-template carouselSlide>
          <div
            class="subscription-type bg-white rounded-10 shadow-sm p-3 ng-star-inserted"
          >
            <a href="javascript:void(0)">
              <div class="row mx-0">
                <div class="col-auto px-0 align-self-center">
                  <img
                    [src]="logos[item.value?.toLowerCase()]"
                    [alt]="item.value"
                    class="img-fluid pe-2 pe-md-3 sport-img max-100"
                  />
                </div>
                <div class="col px-0">
                  <h6 class="text-blue fw-bold">{{ item.name }}</h6>
                  <div class="d-flex small text-dark mb-1">
                    <span class="me-2">Rank: </span>
                    <span class="fw-bold">{{
                      item.rank == "0" ? "NR" : "#" + item.rank
                    }}</span>
                  </div>
                  <div class="d-flex small text-dark justify-content-between">
                    <span>winnings: </span>
                    <span class="text-end fw-bold text-blue">{{
                      item.winnings || 0 | CustomCurrency
                    }}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </owl-carousel-o>
</ng-container>
